// @ts-nocheck
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { FiCheck, FiAlertTriangle } from 'react-icons/fi';

type CustomToastProps = {
  title: string;
  description?: string;
  type: 'success' | 'error';
};

export const CustomToast = ({ title, description, type }: CustomToastProps) => {
  const isSuccess = type === 'success';
  const bgColor = isSuccess ? '#4CAF50' : '#EF5350';
  const IconComponent = isSuccess ? FiCheck : FiAlertTriangle;

  return (
    <Flex direction="column" align="center" textAlign="center" py={4} px={2}>
      <Box
        bg={bgColor}
        borderRadius="full"
        w={{ base: '60px', md: '80px' }}
        h={{ base: '60px', md: '80px' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        mb={{ base: 4, md: 6 }}
      >
        <Icon
          as={IconComponent}
          w={{ base: 8, md: 10 }}
          h={{ base: 8, md: 10 }}
          color="white"
          strokeWidth={3}
        />
      </Box>
      <Text
        fontSize={{ base: 'lg', md: 'xl' }}
        fontWeight="bold"
        color="gray.900"
        mb={description ? 2 : 0}
        px={{ base: 1, md: 4 }}
      >
        {title}
      </Text>
      {description && (
        <Text
          fontSize={{ base: 'sm', md: 'md' }}
          color="gray.500"
          px={{ base: 1, md: 4 }}
        >
          {description}
        </Text>
      )}
    </Flex>
  );
};

export default CustomToast;
